import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-946f9712"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pl-4 pr-2 grid place-items-center"
}
const _hoisted_2 = ["value", "type", "placeholder"]
const _hoisted_3 = {
  key: 1,
  class: "flex"
}

import { defineComponent, Directive, ref } from 'vue';
import CreditCardInputMask from 'credit-card-input-mask';

interface Props {
  pattern?: string;
  label?: string;
  placeholder?: string;
  error?: boolean;
  modelValue?: string | number;
  inline?: boolean;
}

type MaskedInput = HTMLInputElement & { masked?: CreditCardInputMask };

export default /*#__PURE__*/_defineComponent({
  props: {
    pattern: { default: undefined },
    label: { default: '' },
    placeholder: { default: '' },
    error: { type: Boolean },
    modelValue: { default: undefined },
    inline: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: emits }) {



defineComponent({
  inheritAttrs: false,
});


const onInput = (ev: Event) => {
  emits('update:modelValue', (ev.target as HTMLInputElement).value);
};

// inspired by: https://github.com/Scrum/vue-restricted-input/blob/master/src/directive.ts
const vPattern: Directive<MaskedInput, string | undefined> = {
  beforeMount(element, binding) {
    if (!binding.value) return;
    element.masked = new CreditCardInputMask({
      element,
      pattern: binding.value,
    });
  },
  updated(element, binding) {
    if (element.masked && binding.value) {
      element.masked.setPattern(binding.value);
    }
  },
};
const focused = ref(false);

const input = ref<HTMLInputElement>();
const focus = () => {
  input.value?.focus();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative input-wrapper hover:border-gray-400", { focused: focused.value, 'is--error': __props.error, 'input-wrapper--inline': __props.inline }]),
    onClick: focus
  }, [
    (_ctx.$slots['head-icon'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "head-icon")
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("input", _mergeProps({
      ref_key: "input",
      ref: input
    }, _ctx.$attrs, {
      value: __props.modelValue,
      class: ["relative bg-transparent w-full rounded-lg", [
        _ctx.$slots['head-icon'] ? 'pl-2' : 'pl-4 ',
        _ctx.$slots['tail-icon'] ? 'pr-2' : 'pr-4',
      ]],
      type: (_ctx.$attrs.type as string) || 'text',
      placeholder: __props.placeholder,
      onChange: onInput,
      onKeyup: onInput,
      onFocus: _cache[0] || (_cache[0] = ($event: any) => (focused.value = true)),
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (focused.value = false))
    }), null, 16, _hoisted_2), [
      [vPattern, __props.pattern]
    ]),
    (_ctx.$slots['tail-icon'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "tail-icon")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})